import { render } from "./form-label.vue?vue&type=template&id=738ce81f"
import script from "./form-label.vue?vue&type=script&lang=js"
export * from "./form-label.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__